// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Blockquote_wrapper__1eEGl"};